/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IHsoCheckoutDeliveryOptions contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum filterDeliveryModeOption {
    none = 'none',
    filterOutNonCarrierDeliveryMode = 'filterOutNonCarrierDeliveryMode'
}

export const enum useDefaultDeliveryOption {
    none = 'none',
    displaySelectedDeliveryOption = 'displaySelectedDeliveryOption',
    notDisplaySelectedDeliveryOption = 'notDisplaySelectedDeliveryOption'
}

export interface IHsoCheckoutDeliveryOptionsConfig extends Msdyn365.IModuleConfig {
    heading?: IHeadingData;
    filterDeliveryModeOption?: filterDeliveryModeOption;
    useDefaultDeliveryOption?: useDefaultDeliveryOption;
    className?: string;
    multipleAddressShippingEnabled?: boolean;
    enableRequestDeliveryDate?: boolean;
    imageSettings?: Msdyn365.IImageSettings;
    clientRender?: boolean;
    timeoutToCallRetail?: number;
}

export interface IHsoCheckoutDeliveryOptionsResources {
    deliveryOptionsNotFound: string;
    genericErrorMessage: string;
    errorMessageTitle: string;
    ariaLabelText: string;
    priceFree: string;
    saveBtnLabel: string;
    editBtnLabel: string;
    cancelBtnLabel: string;
    deliveryOptionAriaLabel: string;
    cartLineGroupShippingAddressLabel: string;
    cartLineGroupDeliveryOptionsLabel: string;
    cartLineGroupDeliveryOptionsText: string;
    cartLineGroupDeliveryRequestDeliveryDate: string;
    cartLineGroupDeliveryRequestDeliveryDateDisclaimerText: string;
    cartLineGroupDeliveryRequestDeliveryDateText: string;
    discountStringText: string;
    discountOffStringText: string;
    quantityDisplayString: string;
    productDimensionTypeColor: string;
    productDimensionTypeSize: string;
    productDimensionTypeStyle: string;
    productDimensionTypeAmount: string;
    configString: string;
    shippingChargesString: string;
    changeButtonText: string;
    deliveryMethodLabel: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface IHsoCheckoutDeliveryOptionsProps<T> extends Msdyn365.IModule<T> {
    resources: IHsoCheckoutDeliveryOptionsResources;
    config: IHsoCheckoutDeliveryOptionsConfig;
}
